import dynamic from 'next/dynamic';

import AboutSection from '@/components/UI/AboutSection/AboutSection';
import HeroSection from '@/components/UI/HeroSection/HeroSection';
import { Routes } from '@/constants/routes';

import PageLayout from '../PageLayout/PageLayout';

// Below-the-fold sections are loaded after the hero is interactive, keeping
// the critical JS bundle smaller and reducing main-thread parse time at LCP.
const TechStack = dynamic(() => import('@/components/UI/TechStack/TechStack'));
const WorkExperienceSection = dynamic(
  () => import('@/components/UI/WorkExperienceSection/WorkExperienceSection'),
);

const LandingPage = () => {
  return (
    <PageLayout route={Routes.LANDING_PAGE}>
      <HeroSection />
      <TechStack />
      <AboutSection />
      <WorkExperienceSection />
    </PageLayout>
  );
};

export default LandingPage;
